import ReservePattern from "../../../assets/images/Reserve-pattern.svg";
// import ReserveVid from "../../../assets/videos/Reserve-vid.mp4";
import vid3 from "../../../assets//videos/vid3.mp4";
import vid4 from "../../../assets//videos/vid4.mp4";

function ReservationVideo() {
  return (
    <div className="leap-mx-auto leap-relative">
      {/* <img
        src={ReservePattern}
        alt="Reservation pattern"
        className="leap-w-[75%] leap-mx-auto leap-h-auto leap-object-cover leap-z-10 leap-relative"
        loading="lazy"
      />
      <div className="leap-absolute leap-w-[91%] leap-aspect-[5/2] leap-top-[7%] leap-left-[7%]">
        <video
          className="leap-w-full leap-h-full"
          autoPlay
          loop
          muted
          playsInline
          //   style={{
          //     transform: "scaleX(1.2)",
          //     border: "2px solid transparent",
          //     borderImage:
          //       "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
          //     borderImageSlice: 1,
          //   }}
        >
          <source src={vid4} type="video/mp4" />
        </video>
      </div> */}
    </div>
  );
}

export default ReservationVideo;
